import routes from './routes';
import { SetRoutes } from 'components';

const OperationsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default OperationsPages;
